(function (scope, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else scope.FMTBuilderCore = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  function count(value, max) {
    if (typeof value !== 'number' && !(typeof value === 'string' && /^\d{1,6}$/.test(value))) return 0;
    var n = Number(value);
    return Number.isSafeInteger(n) && n >= 0 ? Math.min(n, max == null ? 100000 : max) : 0;
  }
  function cents(value) { return Math.round(Number(value || 0) * 100); }
  function text(value, max) { return typeof value === 'string' ? value.slice(0, max) : ''; }
  function plain(value) { return value && typeof value === 'object' && !Array.isArray(value) ? value : {}; }
  function choice(value, allowed, fallback) { return allowed.indexOf(value) >= 0 ? value : fallback; }

  function normalize(input, catalog, defaults, stepCount) {
    input = plain(input);
    var out = Object.assign({}, defaults, { qty: {}, quality: {}, openGroups: {}, discs: {}, formats: [] });
    var groups = catalog.groups || [];
    // Move older saved DVD selections out of the former videotape category.
    var discGroup = groups.find(function (g) { return g.id === 'video-disc'; });
    if (discGroup) {
      var migratedQty = Object.assign({}, plain(input.qty)), moved = false;
      (discGroup.lines || []).forEach(function (line) {
        var oldKey = 'tape:' + line.k, newKey = 'video-disc:' + line.k;
        if (!Object.prototype.hasOwnProperty.call(migratedQty, newKey) && count(migratedQty[oldKey]) > 0) {
          migratedQty[newKey] = migratedQty[oldKey];
          moved = true;
        }
      });
      var migratedFormats = Array.isArray(input.formats) ? input.formats.slice() : [];
      if (moved && migratedFormats.indexOf('tape') >= 0) {
        if (migratedFormats.indexOf('video-disc') < 0) migratedFormats.push('video-disc');
        var tapeGroup = groups.find(function (g) { return g.id === 'tape'; });
        if (!tapeGroup || !tapeGroup.lines.some(function (l) { return count(migratedQty['tape:' + l.k]) > 0; })) {
          migratedFormats = migratedFormats.filter(function (id) { return id !== 'tape'; });
        }
      }
      input = Object.assign({}, input, { qty: migratedQty, formats: migratedFormats });
    }
    var ids = groups.map(function (g) { return g.id; }).concat('unsure');
    out.formats = Array.isArray(input.formats) ? input.formats.filter(function (id, i, a) {
      return typeof id === 'string' && ids.indexOf(id) >= 0 && a.indexOf(id) === i;
    }) : [];
    var quantities = plain(input.qty), quality = plain(input.quality), opened = plain(input.openGroups);
    groups.forEach(function (g) {
      if (g.quality) out.quality[g.id] = choice(quality[g.id], g.quality.map(function (q) { return q.k; }), g.quality[0] && g.quality[0].k);
      out.openGroups[g.id] = opened[g.id] === true;
      (g.lines || []).forEach(function (l) { out.qty[g.id + ':' + l.k] = count(quantities[g.id + ':' + l.k]); });
    });
    out.step = Math.min(count(input.step), Math.max(0, stepCount - 1));
    out.reached = Math.min(Math.max(out.step, count(input.reached)), Math.max(0, stepCount - 1));
    out.logistics = choice(input.logistics, ['drop', 'kit', 'ship'], null);
    out.dropoff = choice(String(input.dropoff || ''), (catalog.dropoffs || []).map(function (d) { return String(d.k); }), null);
    out.drive = choice(String(input.drive || ''), (catalog.drives || []).map(function (d) { return String(d.k); }), 'none');
    out.driveQty = Math.max(1, count(input.driveQty, 100));
    out.speed = choice(input.speed, ['std', 'exp', 'rush'], 'std');
    out.repairQty = 0;
    out.editingQty = 0;
    (catalog.discs || []).forEach(function (d) { out.discs[d.k] = count(plain(input.discs)[d.k], 100); });
    out.fixLevel = choice(input.fixLevel, ['none', 'basic', 'full'], 'none');
    var images = 0;
    groups.forEach(function (g) {
      if (out.formats.indexOf(g.id) < 0 || ['photo', 'slide'].indexOf(g.id) < 0) return;
      g.lines.forEach(function (l) { images += out.qty[g.id + ':' + l.k]; });
    });
    out.fixQty = out.fixLevel === 'none' ? 0 : count(input.fixQty, images);
    out.keepOriginals = input.keepOriginals !== false;
    out.inspectFirst = true;
    out.marketing = input.marketing === true && (!catalog.marketingOptIn || catalog.marketingOptIn.show !== false);
    out.name = text(input.name, 150);
    out.email = text(input.email, 254);
    out.notes = text(input.notes, 3000);
    out.quoteMode = false;
    out.error = '';
    return out;
  }

  function resolveVariant(variants, match) {
    if (!Array.isArray(variants)) return null;
    var candidates = variants.filter(function (v) {
      return !match || String(v.title).toLowerCase().indexOf(String(match).toLowerCase()) >= 0;
    });
    if (match && candidates.length !== 1) return null;
    if (!match && candidates.length !== 1) return null;
    var v = candidates[0];
    return v && v.available !== false && Number.isSafeInteger(Number(v.id)) ? v : null;
  }

  function signature(item) {
    var props = plain(item.properties);
    return String(item.variant_id || item.id) + '|' + JSON.stringify(Object.keys(props).sort().map(function (k) { return [k, String(props[k])]; }));
  }
  function desiredItems(items, project) {
    if (!/^[a-zA-Z0-9_-]{8,80}$/.test(project)) throw new Error('Your project could not be identified. Reload the builder and try again.');
    var result = [];
    items.forEach(function (item) {
      if (!Number.isSafeInteger(Number(item.id)) || Number(item.id) <= 0 || count(item.quantity) !== item.quantity || !item.quantity) {
        throw new Error('One of your selections needs attention. Please review the quantities.');
      }
      var copy = { id: Number(item.id), quantity: item.quantity, properties: Object.assign({}, plain(item.properties), { _fmt_project: project, _fmt_builder: 'v4' }) };
      var same = result.find(function (r) { return signature(r) === signature(copy); });
      if (same) same.quantity += copy.quantity;
      else result.push(copy);
    });
    return result;
  }
  function owned(item, project) { return item.properties && item.properties._fmt_project === project && item.properties._fmt_builder === 'v4'; }
  function plan(cart, desired, project) {
    var items = cart.items || [], additions = [], updates = {};
    desired.forEach(function (target) {
      var matches = items.filter(function (i) { return owned(i, project) && signature(i) === signature(target); });
      if (!matches.length) additions.push(target);
      matches.forEach(function (item, index) {
        var qty = index === 0 ? target.quantity : 0;
        if (item.quantity !== qty) updates[item.key] = qty;
      });
    });
    items.forEach(function (item) {
      if (owned(item, project) && !desired.some(function (d) { return signature(d) === signature(item); })) updates[item.key] = 0;
    });
    return { additions: additions, updates: updates };
  }
  function verify(cart, desired, project, expectedCents) {
    var selected = (cart.items || []).filter(function (i) { return owned(i, project); });
    if (selected.length !== desired.length || desired.some(function (d) {
      return !selected.some(function (s) { return signature(d) === signature(s) && d.quantity === s.quantity; });
    })) throw new Error('Your cart could not be matched to this project. Your selections are saved; please try again.');
    var actual = selected.reduce(function (sum, item) { return sum + item.final_line_price; }, 0);
    if (!Number.isSafeInteger(actual) || actual !== expectedCents) {
      var error = new Error('The checkout price does not match your estimate. Please contact us to confirm the price before continuing. Your selections are saved.');
      error.code = 'PRICE_MISMATCH';
      error.expectedCents = expectedCents;
      error.actualCents = actual;
      throw error;
    }
    return { cart: cart, projectCents: actual, otherItemCount: (cart.items || []).filter(function (i) { return !owned(i, project); }).reduce(function (sum, i) { return sum + i.quantity; }, 0) };
  }
  async function reconcile(options) {
    var desired = desiredItems(options.items, options.project);
    if (!desired.length) throw new Error('Add at least one item to your project first.');
    var base = options.root || '/';
    async function request(path, body) {
      var response = await options.fetch(base + path, {
        method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: body ? JSON.stringify(body) : undefined
      });
      var value;
      try { value = await response.json(); } catch (_) { throw new Error('We could not confirm the cart response. Your selections are saved; please try again.'); }
      if (!response.ok) throw new Error(value.description || value.message || 'We could not update your cart. Please try again.');
      return value;
    }
    var cart = await request('cart.js');
    var first = plan(cart, desired, options.project);
    // Release obsolete owned quantities before replacements, so editing notes
    // does not temporarily require twice the available stock of the same SKU.
    var reductions = {};
    (cart.items || []).forEach(function (item) {
      if (Object.prototype.hasOwnProperty.call(first.updates, item.key) && first.updates[item.key] < item.quantity) reductions[item.key] = first.updates[item.key];
    });
    if (Object.keys(reductions).length) {
      await request('cart/update.js', { updates: reductions });
      cart = await request('cart.js');
      first = plan(cart, desired, options.project);
    }
    // No automatic retries of a write. A retry starts with a fresh read and uses
    // the project marker to recognize any prior write whose response was lost.
    if (first.additions.length) {
      await request('cart/add.js', { items: first.additions });
      cart = await request('cart.js');
    }
    var second = plan(cart, desired, options.project);
    if (Object.keys(second.updates).length) {
      await request('cart/update.js', { updates: second.updates });
      cart = await request('cart.js');
    }
    return verify(cart, desired, options.project, options.expectedCents);
  }
  return { count: count, cents: cents, normalize: normalize, resolveVariant: resolveVariant, desiredItems: desiredItems, plan: plan, verify: verify, reconcile: reconcile };
});
